import VisuallyHidden from './lib/fire-visually-hidden'

export default VisuallyHidden
